window.Credito = Backbone.Model.extend({

});

window.Creditos = Backbone.Collection.extend({
    model: Credito
});